import * as React from 'react';

import {Checkbox} from 'shells/checkbox/checkbox';

import {SummarizeCheckboxUpsell} from './summarize-checkbox-upsell';

type Props = {
    shouldSummarize: boolean;
    setShouldSummarize: (arg1: boolean) => void;
};

export function SummarizeCheckbox(props: Props) {
    if (!NutClientConfig.canUseAiToken) {
        return <SummarizeCheckboxUpsell />;
    }

    return (
        <Checkbox
            label='Include this summary ✨'
            checked={props.shouldSummarize}
            disabled={false}
            onChange={(checked) => props.setShouldSummarize(checked)}
        />
    );
}
